<section class="form-group">
	<div class="input-group app-dynamic-container">
		<label for="{{id}}" class="ovale ovale-special" [ngClass]="{'ovale-animation': animate }">
			{{myLabel}}
		</label>
		<span class="optional-field">{{optional}}</span>
		<span class="required-field">{{required}}</span>
		<input #input id="{{id}}" type="text" class="form-control"  (blur)="onBlur()" mask="39/19/9999"
			   (input)="onInputChange()" placeholder="{{myLabel}}" [ngClass]="{'is-invalid': invalid}"
			   (focusout)="handleLabel()" autocomplete="chrome-off"
		>
	</div>
</section>
